export default {
    name: 'About'
}